const fetchClubs = () =>
  fetch(`${process.env.APP_API_URL}shops?key=${process.env.APP_API_KEY}`);

export default fetchClubs;
